var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Image from '../Image/Image';
import Label from '../Label/Label';
import Status from '../Status/Status';
import { createShorthandFactory, customPropTypes, UIComponent, commonPropTypes, } from '../../lib';
/**
 * An avatar is a graphic representation of user.
 */
var Avatar = /** @class */ (function (_super) {
    __extends(Avatar, _super);
    function Avatar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Avatar.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest, styles = _a.styles, variables = _a.variables;
        var _b = this.props, name = _b.name, status = _b.status, image = _b.image, label = _b.label, getInitials = _b.getInitials;
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }),
            Image.create(image, {
                defaultProps: {
                    fluid: true,
                    avatar: true,
                    title: name,
                    styles: styles.image,
                },
            }),
            !image &&
                Label.create(label || {}, {
                    defaultProps: {
                        content: getInitials(name),
                        circular: true,
                        title: name,
                        styles: styles.label,
                    },
                }),
            Status.create(status, {
                defaultProps: {
                    styles: styles.status,
                    variables: {
                        borderColor: variables.statusBorderColor,
                        borderWidth: variables.statusBorderWidth,
                    },
                },
            })));
    };
    Avatar.className = 'ui-avatar';
    Avatar.displayName = 'Avatar';
    Avatar.propTypes = __assign({}, commonPropTypes.createCommon({
        children: false,
        content: false,
    }), { name: PropTypes.string, image: customPropTypes.itemShorthand, label: customPropTypes.itemShorthand, size: PropTypes.number, status: customPropTypes.itemShorthand, getInitials: PropTypes.func });
    Avatar.defaultProps = {
        size: 32,
        getInitials: function (name) {
            if (!name) {
                return '';
            }
            var reducedName = name
                .replace(/\s*\(.*?\)\s*/g, ' ')
                .replace(/\s*{.*?}\s*/g, ' ')
                .replace(/\s*\[.*?]\s*/g, ' ');
            var initials = reducedName
                .split(' ')
                .filter(function (item) { return item !== ''; })
                .map(function (name) { return name.charAt(0); })
                .reduce(function (accumulator, currentValue) { return accumulator + currentValue; });
            if (initials.length > 2) {
                return initials.charAt(0) + initials.charAt(initials.length - 1);
            }
            return initials;
        },
    };
    return Avatar;
}(UIComponent));
Avatar.create = createShorthandFactory(Avatar, 'name');
export default Avatar;
